module.exports = __webpack_public_path__ + "img/left_4.3c3a6ab8.jpg";